exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-container {\r\n    text-align: center;\r\n    margin: auto;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./src/containers/CertPage/AuditPage.css
// module id = 3001
// module chunks = 0